import { useEffect } from 'react';

import { HeatmapColorScheme } from '@strava/mre';

import { clamp } from '../../helpers/clamp';
import { useMRE } from '../../hooks/useMRE';

interface WeeklyHeatmapProps {
  // The MRE isn't aware of and does not validate the list of allowed activityType values; the string is just
  // included in a tile-request URL. Currently, the "source of truth" for the allowed activityType values for
  // the web project is in the feature-maps package; and we accept any value here. We do not want to import
  // FROM the feature-maps package into this package.
  activityType: string;
  opacityMultiplier?: number; // number between 0 and 1
}

export const WeeklyHeatmap = ({
  activityType,
  opacityMultiplier = 1
}: WeeklyHeatmapProps) => {
  const { terrainEngine } = useMRE();

  useEffect(() => {
    if (!terrainEngine) {
      return;
    }

    terrainEngine.setWeeklyHeatmapConfig({
      activityType,
      colorScheme: HeatmapColorScheme.WEEKLY_RAINBOW,
      opacityMultiplier: clamp(opacityMultiplier, 0, 1)
    });

    // We don't cleanup each time config changes. That would result in unnecessary
    // extra calls to the API.
  }, [terrainEngine, activityType, opacityMultiplier]);

  useEffect(() => {
    if (terrainEngine) {
      // We do cleanup when the component unmounts.
      return () => {
        terrainEngine.setWeeklyHeatmapConfig(undefined);
      };
    }
  }, [terrainEngine]);

  return null;
};
